import { render, staticRenderFns } from "./EmojiPickerButton.vue?vue&type=template&id=41cfdeb9&lang=pug&"
import script from "./EmojiPickerButton.vue?vue&type=script&lang=js&"
export * from "./EmojiPickerButton.vue?vue&type=script&lang=js&"
import style0 from "./EmojiPickerButton.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports